import { MobileSidebarLink } from "@/components/Navigation";
import { INavItem } from "@/navigation/navigation";
import { faCaretDown, faCaretUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "flex w-full flex-col",
    toggle: "flex flex-row justify-between bg-secondary-light px-30 py-20",
    activeItem: "flex flex-row items-center gap-30",
    linksContainer: "flex flex-col",
  },
  variants: {
    isOpen: {
      true: {
        base: "min-h-screen",
      },
    },
  },
});

interface IProps {
  activeMenuItem: INavItem | undefined;
  openMenu: IOpenMenuType;
  toggleOpen: () => void;
}

const MobileSidebar = ({ activeMenuItem, openMenu, toggleOpen }: IProps) => {
  const { pathname } = useLocation();

  const { base, toggle, activeItem, linksContainer } = styles({
    isOpen: openMenu === "MOBILE_SIDEBAR",
  });

  const activeSidebarItem = activeMenuItem?.sidebar?.find(item => {
    const parsedItemUrl = item.url.split("?")[0];
    return pathname === `${activeMenuItem?.url}${parsedItemUrl}`;
  });

  const renderLinks = () =>
    activeMenuItem?.sidebar
      .filter(item => item !== activeSidebarItem)
      .filter(({ hidden, locked }) => !!!locked?.() && !!!hidden?.())
      .map(({ url, title, external, newTab, icon }, index) => {
        const fullUrl = external ? url : `${activeMenuItem.url}${url}`;

        return (
          <MobileSidebarLink
            key={index}
            url={fullUrl}
            title={title}
            external={!!external}
            newTab={!!newTab}
            icon={icon}
            closeMenu={toggleOpen}
          />
        );
      });

  return (
    <div className={base()}>
      <div className={toggle()} onClick={toggleOpen}>
        <div className={activeItem()}>
          {!!activeSidebarItem?.icon && (
            <FontAwesomeIcon
              fixedWidth
              icon={activeSidebarItem?.icon}
              className="h-25 w-25"
            />
          )}
          {activeSidebarItem?.title}
        </div>
        <div>
          <FontAwesomeIcon
            fixedWidth
            icon={openMenu === "MOBILE_SIDEBAR" ? faCaretUp : faCaretDown}
          />
        </div>
      </div>
      {openMenu === "MOBILE_SIDEBAR" && (
        <div className={linksContainer()}>{renderLinks()}</div>
      )}
    </div>
  );
};

export default MobileSidebar;
